/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 React Base Styles
import colors from "assets/theme-dark/base/colors";
import rgba from "assets/theme-dark/functions/rgba";

const { transparent, white, text, background } = colors;

const textField = {
  styleOverrides: {
    root: {
      backgroundColor: transparent.main,
      "& .MuiInputBase-root": {
        color: white.main,
      },
      "& .MuiInputLabel-root": {
        color: rgba(text.main, 0.92),
      },
      "& .MuiFormHelperText-root": {
        color: rgba(text.main, 0.72),
      },
      "& .MuiInputBase-input::placeholder": {
        color: rgba(text.main, 0.62),
        opacity: 1,
      },
      "& .MuiInputBase-input:-webkit-autofill": {
        WebkitTextFillColor: white.main,
        WebkitBoxShadow: `0 0 0 100px ${background.card} inset`,
      },
    },
  },
};

export default textField;
